module.exports = __webpack_public_path__ + "img/logo.42176cc2.png";